var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8978 10.3228C28.3343 15.7383 31.3964 20.5387 34.8329 25.9675C36.2369 28.829 33.5492 33.3754 30.6075 33.3754H28.0134C22.5444 33.362 17.0888 33.362 11.6332 33.3352C7.1404 33.3085 6.07068 29.8185 7.22063 27.8128C10.8577 21.9828 14.4814 16.1394 18.1318 10.3228C19.9102 7.96944 23.0793 8.14327 24.8978 10.3228Z",
    fill: "#E7B571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2053 13.1576C27.7861 17.2092 30.0726 20.8061 32.6399 24.8577C33.8032 26.8768 31.6905 30.4069 29.4842 30.4069H27.5454C23.4537 30.3935 19.3754 30.3935 15.2837 30.3801C11.9274 30.3534 11.1251 27.7459 11.9943 26.2483C14.7087 21.8758 17.4231 17.5167 20.1509 13.1576C21.4881 11.3925 24.042 11.5129 25.2053 13.1576Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.446 15.2302C27.3181 18.1719 28.9761 20.7794 30.8481 23.7211C31.4766 25.3123 30.1528 27.7459 28.5482 27.7459H27.1442C24.1757 27.7459 21.2206 27.7326 18.2522 27.7192C15.8185 27.7058 15.2302 25.8071 15.8586 24.724C17.8376 21.5683 19.8033 18.3859 21.7822 15.2302C22.745 13.9599 24.4031 14.0535 25.446 15.2302Z",
    fill: "#E7B571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6199 16.7679C27.0239 18.9742 28.2674 20.9265 29.6581 23.1194C30.1261 24.2693 29.1366 26.1414 27.9465 26.1414L26.8902 26.128C24.6705 26.128 22.4508 26.128 20.2445 26.1146C18.4126 26.1146 17.9847 24.6839 18.4527 23.8682C19.9236 21.5014 21.3945 19.1347 22.8787 16.7679C23.6008 15.8185 24.7908 15.872 25.6199 16.7679Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg49);
export default __webpack_public_path__ + "static/media/49.c36ce0d69417f9f98e8da66846c977c5.svg";
export { ForwardRef as ReactComponent };